import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mention-legales',
  templateUrl: './mention-legales.component.html',
  styleUrls: ['./mention-legales.component.scss']
})
export class MentionLegalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
